import React from "react"
import { PatientsLink } from "./PatientsLink"
import { MobergFontFamily } from "../../../../../Components/MobergFont/MobergFont"

type SubHeaderProps = {
    startSlotChildren?: Element | Element[]
    endSlotChildren?: Element | Element[]
    patient?: {
        patient_id: string
        site_name: string
        site_identifier: string
    }
    backNavigate?: boolean
}

export const SubHeader: React.FC<SubHeaderProps> = ({ patient, startSlotChildren, endSlotChildren, backNavigate=false }) => {
    
    return (
        <div style={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between', gap: "32px", flexDirection: "row", fontFamily: MobergFontFamily.REGULAR, fontSize: "16px", height: "40px", padding: "24px 0px"}}>
            <div style={{  display: "flex", gap: "32px", alignItems: "center" }}>
                <PatientsLink />
                {startSlotChildren}
            </div>

            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", color: "var(--text-secondary-color)", fontWeight: "500" }}>
                <span style={{ color: "var(--color-text-primary)", fontWeight: "600", fontSize: "14px" }}>{patient?.site_identifier}</span>
                <span>•</span>
                <span style={{  fontSize: "14px" }}>{patient?.site_name}</span>
                <span>•</span>
                <span style={{ color: "var(--color-text-primary)", fontWeight: "600", fontSize: "14px" }}>Patient {patient?.patient_id}</span>
            </div>

            <div style={{  display: "flex", alignItems: "center", justifyContent: "end" }}>
                {endSlotChildren}
            </div>
        </div>
    )
}
